import { useTranslation } from "react-i18next";
import { useBranding } from "../../../contexts/branding";

interface AppleAppStoreLinkProps {
    onClick?: () => void;
}

export default function AppleAppStoreLink({ onClick }: AppleAppStoreLinkProps) {
    const { t } = useTranslation();
    const { appStoreUrl } = useBranding();
    if (!appStoreUrl || appStoreUrl === "null") {
        return null;
    }
    return (
        <a
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
        >
            <img
                src="/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                alt={t("Download from on App Store")}
                height={56}
                width={188.95}
            />
        </a>
    );
}
